import axios from "axios"
import { ADD_TO_CART, DELETE_FROM_CART } from "./cartActionTypes"


export const getCartData=(payload)=>(dispatch)=>{
    axios.get("https://anthro-backen.onrender.com/cart").then((res)=>{
        console.log(res,"res in cart")
        dispatch({type:ADD_TO_CART,payload:res.data})
        return res.data
    })
    
}


export const deleteCartData=(id)=>(dispatch)=>{
    axios.delete(`https://anthro-backen.onrender.com/cart/${id}`)
    axios.get("https://anthro-backen.onrender.com/cart").then((res)=>{
      
    dispatch({type:ADD_TO_CART,payload:res.data})
    })

    
}